import React from 'react'
import RenderPrintPdf from '../../../../components/Impressao/RenderPrintPdf'
import TGOPdfDocument from '../../../../template/pdf/TGO/TGO'

export const renderPrintPdf = ({ guiaServico, urlLogo, pdfToPrint, onAfterPrint }) => (
  <RenderPrintPdf
    pdfDocument={<TGOPdfDocument guiaServico={guiaServico} urlLogo={urlLogo} />}
    pdfToPrint={pdfToPrint}
    onAfterPrint={onAfterPrint}
  />
)
